export const getOidcStorageKey = () => {
  const authSettings = JSON.parse(localStorage.getItem("authSettings"));
  if (authSettings) {
    return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
  }
  return null;
};

export const getOidcInfo = () => {
  const key = getOidcStorageKey();
  if (key) {
    const oidc = JSON.parse(localStorage.getItem(key));
    return oidc;
  }
  return null;
};

export const getToken = () => {
  const oidc = getOidcInfo();
  if (oidc) {
    return oidc.id_token;
  }
  return null;
};

const getDay = (date) => {
  if (!date) return "";
  return `${new Date(date)?.getDate()}`;
};

const getValue = (price) => {
  if (Number.isNaN(price)) return 0;
  return Number(price).toFixed(2);
};

const getNameAndValueArr = (history) =>
  history.map((day) => ({
    name: getDay(day?.date),
    value: getValue(day.priceUsd),
  }));

export const getWeekChartData = (cryptoHistory) => {
  if (!cryptoHistory) return null;

  const weekChartDataArr = cryptoHistory?.map((item) => ({
    currency: item?.currency,
    history: getNameAndValueArr(item?.history.slice(7, item?.history.length)),
  }));

  return Object.fromEntries(
    weekChartDataArr.map((item) => [item.currency, item.history])
  );
};

//To check if exisitng service tasks are equal to current service tasks data
export const areObjsEqual = (obj1, obj2) => {
  let objEqual = false;
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);
  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }
  const areEqual = obj1Keys.every((key, index) => {
    const objValue1 = +obj1[key];
    const objValue2 = +obj2[obj2Keys[index]];
    return key === obj2Keys[index] && objValue1 === objValue2;
  });
  if (areEqual) {
    objEqual = true;
  }

  return objEqual;
};

// Vehicle status helpers
// Inactive - veh_active = 0 or veh_active = 2
export const isVehicleInactive = (veh_active) =>
  veh_active === 0 || veh_active === 2;

// Border color based on veh_active and secondary_status
// Active - veh_active = 1 and secondary_status = 0 -> #009BD9 (default)
// Out of Service - veh_active = 1 and secondary_status = 1 -> #FD8C8C
// Inactive - veh_active = 0 or veh_active = 2 -> #828EA8
export const getVehicleBorderColor = (veh_active, secondary_status) => {
  if (isVehicleInactive(veh_active)) {
    return "#828EA8";
  }

  if (veh_active === 1 && secondary_status === 1) {
    return "#FD8C8C";
  }

  // Default / active
  return "#009BD9";
};